
export function apiToUiDateRange({ ReportTime }) {
  return ReportTime.DateRangePreset ?
    { key: ReportTime.DateRangePreset } :
    { key: 'Custom', start: ReportTime.StartDate, end: ReportTime.EndDate };
}

export function uiToApiDateRange(dateRange) {
  return dateRange.key === 'Custom' ?
    { StartDate: dateRange.start, EndDate: dateRange.end } :
    { DateRangePreset: dateRange.key };
}
